import Vue from 'vue'

Vue.filter('currency', function (value) {
  if (!value) return 0
  if (value === null) return 0
  if (value === 'null') return 0
  return new Intl.NumberFormat('pt-BR', {
    maximumFractionDigits: 2,
    style: 'currency',
    currency: 'BRL'
  }).format(value)
})

Vue.filter('decimal', function (value) {
  if (!value) return 0
  if (value === null) return 0
  if (value === 'null') return 0
  return new Intl.NumberFormat('pt-BR', {
    maximumFractionDigits: 2
  }).format(value)
})

Vue.filter('percentage', function (value) {
  if (!value) return 0
  if (value === null) return 0
  if (value === 'null') return 0
  return new Intl.NumberFormat('pt-BR', {
    maximumFractionDigits: 2,
    style: 'percent'
  }).format(value)
})
